import {Inject, Injectable, TemplateRef} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(
    @Inject(Store) private store: Store<any>,
    @Inject(TranslateService) private translateService: TranslateService
  ) {

  }

  toasts: any[] = [];

  success(message) {
    this.show(this.translateService.instant(`alerts.${message}`), { classname: 'bg-success text-light', delay: 5000 });
  }

  error(message) {
    this.show(this.translateService.instant(`alerts.${message}`), { classname: 'bg-danger text-light', delay: 5000 });
  }

  info(message) {
    this.show(this.translateService.instant(`alerts.${message}`), { classname: 'text-light', delay: 5000 });
  }

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }

}
